<script setup>
import { useToastStore } from '../stores/toastStore'

const store = useToastStore()

const getTypeClasses = (type) => {
    switch (type) {
        case 'success':
            return 'bg-green-500 text-white'
        case 'error':
            return 'bg-red-500 text-white'
        case 'warning':
            return 'bg-yellow-500 text-white'
        default:
            return 'bg-blue-500 text-white'
    }
}
</script>

<template>
    <div class="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none" role="status" aria-live="polite" aria-atomic="true">
        <transition-group name="toast">
            <div v-for="toast in store.toasts" :key="toast.id" :class="[
                'pointer-events-auto min-w-[300px] p-4 rounded-lg shadow-lg flex items-center justify-between',
                getTypeClasses(toast.type)
            ]">
                <p class="font-medium text-sm">{{ toast.message }}</p>
                <button @click="store.remove(toast.id)" class="ml-4 opacity-80 hover:opacity-100 focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </transition-group>
    </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
